import { useState } from "react"
import { Api } from "../../api"
import { Button, Col, Container, Form, Row, Card } from "react-bootstrap"
import { useNavigate } from "react-router-dom"
import { LocalAuth } from "../../auth"
import { Toaster, toast } from "sonner"
import  LogoWithoutName  from "../../logo.png"

export const RegisterPage: React.FC = () => {
    const navigate = useNavigate()
    const [name, setName] = useState("")
    const [surname, setSurname] = useState("")
    const [contact, setContact] = useState("")
    const [username, setUsername] = useState<string>("")
    const [password, setPassword] = useState<string>("")
    const [confirmPassword, setConfirmPassword] = useState("")

    const registerHandler = async () => {

          if(name.trim() === ''){
            toast.error("Name is required.")
            return;
          }

          if(surname.trim() === ''){
            toast.error("Surname is required.")
            return;
          }

          if(contact.trim() === ''){
            toast.error("Contact is required.")
            return;
          }

          if(username.trim() === ''){
            toast.error("Email is required.")
            return;
          }

          if(password.trim() === ''){
            toast.error("Password is required.")
            return;
          }

          if(confirmPassword.trim() === ''){
            toast.error("Confirm Password is required.")
            return;
          }

          if(password.length < 4){
            toast.error("The minimum length of the password is 4 charactors.")
            return;
          }

          if(password != confirmPassword){
            toast.error("Please make sure the passwords match.")
            return;
          }

        const response = await Api.accounts.createUser({name, surname, contact,  username, password })

        if(response.error != ''){
            toast.error(response.error)
        }else{
            LocalAuth.setSession(response.token)
            navigate("/events")
        }   
    }
    return (
      

     
        <Container>
             
             <Toaster
              richColors
              position="top-right"
              expand={true}
              />
            <Row>            
                <Col md={2}>
                </Col>
                <Col md={8}>
                <Card className="p-5 shadow">
                    <div className="text-center">
                    <img src={LogoWithoutName} width={70} />
                    <h1 className="lead pb-4">Create New Account</h1>
                    </div>

                    <Form>
                    <Form.Group className="mb-3" controlId="formBasicName">
                            <Form.Label>Name</Form.Label>
                            <Form.Control
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                type="text"
                                placeholder="Name"
                            />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formBasicSurname">
                            <Form.Label>Surname</Form.Label>
                            <Form.Control
                                value={surname}
                                onChange={(e) => setSurname(e.target.value)}
                                type="text"
                                placeholder="Surname"
                            />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formBasicContact">
                            <Form.Label>Contact</Form.Label>
                            <Form.Control
                                value={contact}
                                onChange={(e) => setContact(e.target.value)}
                                type="text"
                                placeholder="Contact"
                            />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>Email address</Form.Label>
                            <Form.Control
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                type="email"
                                placeholder="Enter email"
                            />
                            <Form.Text className="text-muted">
                                We'll never share your email with anyone else.
                            </Form.Text>
                        </Form.Group>

                        <Form.Group
                            className="mb-3"
                            controlId="formBasicPassword"
                        >
                            <Form.Label>Password</Form.Label>
                            <Form.Control
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                type="password"
                                placeholder="Password"
                            />
                        </Form.Group>
                        <Form.Group
                            className="mb-3"
                            controlId="formBasicConfirmPassword"
                        >
                            <Form.Label>Password</Form.Label>
                            <Form.Control
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                type="password"
                                placeholder="Confirm Password"
                            />
                        </Form.Group>
                        <Form.Group
                            className="mb-3"
                            controlId="formBasicCheckbox"
                        >
                        </Form.Group>
                        <Button className="btn btn-block mt-4" style={{backgroundColor: "#f1c400", 
                    borderColor: "#f1c400"}} onClick={registerHandler}>
                            Create Account
                        </Button>
                    </Form>
                     </Card>
                </Col>
               
            </Row>
          
        </Container>
    )
}
